<template>
  <footer class="w-full bg-gray-lightest shrink-0">
    <div
      class="flex gap-x-4 gap-y-6 justify-center md:justify-between px-8 pt-4 pb-6 w-full flex-col md:flex-row-reverse mt-6 items-center h-auto text-xs text-gray-darker"
    >
      <nav class="flex-shrink-0 flex flex-wrap items-center justify-center gap-3">
        <template
          v-for="(link, index) in complianceLinks"
          :key="index"
        >
          <a
            :href="link.href"
            target="_blank"
            class="inline-block whitespace-nowrap"
          >{{ link.linkText }}</a>
          <div
            v-if="index !== complianceLinks.length - 1"
            class="bg-gray-darker w-[1px] self-stretch"
          />
        </template>
      </nav>
      <div class="text-center">
        © Openly LLC. All Rights Reserved.
      </div>
    </div>
  </footer>
</template>
<script setup>
const complianceLinks = [
  {
    linkText: 'Terms of Service',
    href: 'https://openly.com/terms-of-use',
  },
  {
    linkText: 'Legal Disclosures',
    href: 'https://openly.com/legal-disclosures',
  },
  {
    linkText: 'Security Disclosure',
    href: 'https://openly.com/security-disclosure',
  },
  {
    linkText: 'Privacy Policy',
    href: 'https://openly.com/privacy-policy',
  },
]
</script>
